import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { X, KeyRound, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import useAuthStore from '../store/useAuthStore';

export const WelcomeBanner = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const dismissKey = user ? `welcome_banner_dismissed_${user.id}` : null;
  const [dismissed, setDismissed] = useState(
    dismissKey ? localStorage.getItem(dismissKey) === 'true' : true
  );

  if (!user?.has_temp_password || dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(dismissKey, 'true');
    setDismissed(true);
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -12 }}
        className="relative mb-8 rounded-xl border border-orange-300/50 bg-gradient-to-r from-orange-50 to-amber-50 dark:from-orange-950/40 dark:to-amber-950/30 dark:border-orange-800/50 p-4 md:p-5"
        data-testid="welcome-banner"
      >
        <button
          onClick={handleDismiss}
          className="absolute top-3 right-3 text-orange-400 hover:text-orange-600 transition-colors"
          aria-label="Dismiss welcome banner"
          data-testid="welcome-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-4 pr-8">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-orange-500/15 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-orange-500" />
            </div>
            <div>
              <p className="font-semibold text-sm md:text-base" data-testid="welcome-banner-title">
                Welcome, {user.name}! 🎹 You're in with your temporary password.
              </p>
              <p className="text-xs md:text-sm text-muted-foreground">
                Secure your account by setting your own password — it only takes a few seconds.
              </p>
            </div>
          </div>
          <Button
            size="sm"
            onClick={() => navigate('/account')}
            className="md:ml-auto bg-orange-500 hover:bg-orange-600 text-white btn-press flex-shrink-0"
            data-testid="welcome-banner-change-password-btn"
          >
            <KeyRound className="w-4 h-4 mr-2" />
            Change Password
          </Button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default WelcomeBanner;
